import { Box, SxProps, Tooltip } from "@mui/material";
import { Dispatch, FC, SetStateAction } from "react";
import { CancelIcon } from "../../../assets/icons/Icons";
import DefaultIcon from "../DefaultIcon";
import { ActionButtonWrapperStyles } from "../../../pages/groups/GroupsBlock/GroupsBlock.styles";
import { GeneralButton } from "../../../common/ui/GeneralButton";
import { GroupItem } from "../../../types/groupItem";

interface ActionButtonProps {
  actionName: string;
  iconName: string;
  iconUrl: string | null;
  isEditMode?: boolean;
  colorHex?: string;
  sx?: SxProps;
  handleOnEdit?: () => void;
  setSelectedActions?: Dispatch<SetStateAction<GroupItem>>;
  handleActionButtonDelete?: () => void;
}

const ActionButton: FC<ActionButtonProps> = ({
  actionName,
  iconName,
  isEditMode,
  colorHex,
  iconUrl,
  handleActionButtonDelete,
}) => {
  return (
    <ActionButtonWrapperStyles>
      <Tooltip title={actionName}>
        <GeneralButton appVariant="icon">
          <DefaultIcon
            iconName={iconName}
            colorHex={colorHex ?? ""}
            iconUrl={iconUrl}
          />
        </GeneralButton>
      </Tooltip>

      {isEditMode && (
        <Box>
           <GeneralButton
            appVariant="danger"
            onClick={handleActionButtonDelete}
          >
            <CancelIcon />
          </GeneralButton>
        </Box>
      )}
    </ActionButtonWrapperStyles>
  );
};

export default ActionButton;
